
import React from 'react'
import Dialog from './Dialog'
import Button from './Button'
import RemoveButton from './RemoveButton'

/**
 * CornerDialog component.
 */

export default function CornerDialog({ title, text, onClose, onConfirm, theme = 'primary', closeLabel = 'Cancel', confirmLabel = 'Confirm' }) {
  return <div className="CornerDialog">
    <div className="top">
      <span className="title">{title}</span>
      <RemoveButton onClick={onClose} />
    </div>
    <p>{text}</p>
    <div className="actions">
      <button className="Button default">{closeLabel}</button>
      <button className="Button primary">{confirmLabel}</button>
    </div>
  </div>
}